<template>
  <a-form
    ref="formRef"
    layout="vertical"
    :model="{ featureName }"
    name="add_feature"
    @finish="addFeature()"
  >
    <a-alert
      type="info"
      show-icon
      class="mb-3"
      message="A new feature has no effect until the portal code checks for it. Names are stored in upper case."
    />
    <div class="row">
      <div class="col-sm-12">
        <a-form-item
          label="Feature name"
          name="featureName"
          :validate-status="nameError ? 'error' : ''"
          :help="nameError"
          :extra="
            storedName && !nameError ? `Will be stored as ${storedName}` : ''
          "
        >
          <a-input
            v-model:value="featureName"
            placeholder="ex: REALTIME_SUBSCRIPTION"
          />
        </a-form-item>
      </div>
    </div>
    <div class="buttons-w d-flex justify-content-end">
      <a-button
        type="primary"
        html-type="submit"
        :disabled="!storedName || !!nameError"
        :loading="isCreating"
      >
        Create
      </a-button>
    </div>
  </a-form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { apiErrorMessage } from './featureControlMixin';

export default {
  name: 'AddFeature',
  inject: ['toast'],
  emits: ['toggleModal'],
  data() {
    return {
      featureName: '',
      isCreating: false,
    };
  },
  computed: {
    ...mapGetters(['adminFeatures']),
    storedName() {
      return this.featureName.trim().toUpperCase();
    },
    // The backend accepts duplicate names, which would leave two features
    // the portal cannot tell apart, so block them here.
    nameError() {
      if (!this.storedName) return '';
      if (this.storedName.length > 250) {
        return 'Feature names can be at most 250 characters.';
      }
      const existing = this.adminFeatures.find(
        (feature) => String(feature.name).toUpperCase() === this.storedName
      );
      if (!existing) return '';
      return existing.suppressed
        ? `${this.storedName} already exists but is disabled for everyone. Use Re-enable in the By feature tab instead.`
        : `${this.storedName} already exists.`;
    },
  },
  methods: {
    ...mapActions(['adminCreateFeature']),
    async addFeature() {
      if (!this.storedName || this.nameError) return;
      this.isCreating = true;
      const [error] = await this.adminCreateFeature(this.featureName.trim());
      this.isCreating = false;
      if (error) {
        this.toast.error(
          apiErrorMessage(error, `Could not create ${this.storedName}.`)
        );
        return;
      }
      this.toast.success(`${this.storedName} created.`);
      this.$emit('toggleModal', false);
    },
  },
};
</script>
